export default () => {
	return <div className="complication-spacer" />;
};
